angular.module('am4')
.filter('massageProgram', function($translate) {
    return function(input) {
        return input ?
            $translate.instant(input.toUpperCase().replace(' ', '_')) :
            $translate.instant('NA');
    };
});


// WEBPACK FOOTER //
// ./src/app/filters/massageProgram.js